import { Button, Checkbox, Col, ColorPicker, Form, Input, message, Popconfirm, Radio, Row, Select, Space } from "antd";
import { useEffect, useState, useRef } from "react";
import { serverFetch } from "../../../server";
import { datPeriodVids, productLimitVisit, productMarkVids, productMarkVidsMobile, productVids } from "../../../extensions/helper";
import { convertFieldsToFloat, convertFieldsToInt } from "../../../extensions/utils";
import { distsKKMTags1212 } from "../../../extensions/dicts";
import { LogMonitor, Scan, SelectClient } from "../../../controls";
import TakePhoto from "../../../controls/take-photo/take-photo";
import UploadPhoto from "../../../controls/take-photo/upload-photo";
import { isMobile } from "@/extensions/design";
import "./product.css";

const planningVids = [
  { value: 0, label: "Не планировать" },
  { value: 1, label: "Сотрудник" },
  { value: 2, label: "Зал" },
  { value: 3, label: "Группа" },
];

const ProductMain = ({id, onClose, onRefresh, barcode, setVid}) => {
  const [item, setItem] = useState({ vid: barcode ? 0 : 1, active: true, markVid: 0, barcode, putCoeff: 1, trainerSelectionRequirement: 0, saleUseOnVisit: false });
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [calendars, setCalendars] = useState([]);
  const imageRef = useRef(null);
  const [takePhoto, setTakePhoto] = useState(false);
  const [uploadPhoto, setUploadPhoto] = useState(false);
  const [penProductIds, setPenProductsIds] = useState([]);

  const getData = () => {
    if (id) {
      setLoading(true);
      serverFetch(`product/${id}`)
        .then(data => {
          setLoading(false);
          setItem(data);
          form.setFieldsValue(data);
        })
        .catch(e => {
          setLoading(false);
          message.error(e.userMessage);
        })
    }
    else form.setFieldsValue(item);
    serverFetch("calendar")
      .then(data => setCalendars(data.map(i => ({value: i.id, label: i.name}))))
      .catch(e => message.error(e.userMessage));
  }

  const getPenProductIds = () => {
    setLoading(true);
    serverFetch(`product`, { method: 'GET' , queryParams: { vids: '1' }})
      .then(data => {
        setLoading(false);
        setPenProductsIds((data ?? []).map(product => ({
          value: product.id,
          label: product.name,
        })));
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  useEffect(getData, [id, form])

  useEffect(() => {
    if (item?.vid === 1) {
      getPenProductIds();
    } else {
      setPenProductsIds([]);
    }
  }, [item?.vid])

  useEffect(() => {
    setVid(item?.vid);
  }, [item?.vid])

  const onValuesChange = (value) => {
    if (value.color) value.color = value.color.toHexString();
    setItem({ ...item, ...value });
  }; 

  const onPutCoeffBlur = (e) => {
    const raw = e?.target?.value;
    const parsed = Number.parseFloat(raw);
    const next = (raw === "" || Number.isNaN(parsed) || parsed === 0) ? 1 : parsed;
    setItem((prev) => ({ ...prev, putCoeff: next }));
    form.setFieldValue("putCoeff", next);
  };

  const onSave = () => {
    setLoading(true)
    const newItem = convertFieldsToFloat(item, ["expPrice", "syma", "salaryExec", "salarySale", "salaryManager", "salaryNew", "salaryCont", "putPrice", "putCoeff", "restMin", "restMinPart"]);
    const newItem2 = convertFieldsToInt(newItem, ["depno", "limitVisitQty", "freezQty", "freezMin", "srok", "freezSrok", "markUnit", "markNum", "markDen", "duration", "autoActivationDays", "planningVid", "paymentDeadline", "trainerSelectionRequirement"]);
    if (newItem2.autoActivationOnFullPayment !== undefined && newItem2.autoActivationOnFullPayment !== null) {
      newItem2.autoActivationOnFullPayment = !!newItem2.autoActivationOnFullPayment;
    }
    serverFetch("product", { method: id ? "PUT" : "POST", bodyData: newItem2 })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      });
  }

  const onCancel = () => onClose()

  const onCopy = () => {
    setLoading(true);
    serverFetch(`product/copy/${id}`, { method: "POST" })
      .then(data => {
        onRefresh(data.id);
      })
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const onDelete = () => {
    setLoading(true);
    serverFetch(`product/${id}`, { method: "DELETE" })
      .then(() => onClose(true))
      .catch(e => {
        setLoading(false);
        message.error(e.userMessage);
      })
  }

  const onScan = value => {
    setItem({...item, barcode: value });
    form.setFieldValue("barcode", value);
  }

  const onClosePhoto = (refresh) => {
    setTakePhoto(false);
    refresh && getData();
  }

  const onCloseUpload = (refresh) => {
    setUploadPhoto(false);
    refresh && getData();
  }

  const onSavePhoto = (file) => {
    const formData = new FormData();
    formData.append('file', file, file.name);
    serverFetch(`product/photo/${id}`, { method: "PUT", body: formData })
      .then(() => {
        const timestamp = Date.now();
        setItem((prev) => ({ ...prev, updatedAt: timestamp }));
        onClosePhoto(true);
      })
      .catch(e => message.error(e.userMessage));
  };

  const onDeletePhoto = () => {
    const formData = new FormData();
    serverFetch(`product/photo/${id}`, { method: "PUT", body: formData })
      .then(() => {
        const timestamp = Date.now();
        setItem((prev) => ({ ...prev, updatedAt: timestamp }));
        onClosePhoto(true);
      })
      .catch(e => message.error(e.userMessage));
  };

  return !isMobile ? <>
  <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 6 }} wrapperCol={{ span: 24 }} colon={false} disabled={loading}>
          <Form.Item label=" " className="sport-section-title sport-modal-group-item">Основное</Form.Item>
          <Form.Item label=" " className="sport-modal-group-item">
            <Row gutter={8}>
              <Col span={4}><Form.Item name="active" valuePropName="checked" noStyle><Checkbox>Активный</Checkbox></Form.Item></Col>
              <Col span={20}><Form.Item label="Вид" name="vid" labelCol={{span: 12}} wrapperCol={{span: 12}}><Select options={productVids}/></Form.Item></Col>
            </Row>
          </Form.Item>
          <Form.Item label="Наименование" name="name"><Input /></Form.Item>
          <Form.Item label="Описание" name="description"><Input.TextArea rows={3}/></Form.Item>
          <Form.Item label="Продажа, цена" className="sport-modal-group-item">
            <Row gutter={8}>
              <Col span={4}><Form.Item name="expPrice" noStyle><Input /></Form.Item></Col>
              <Col span={10}><Form.Item label="Единица" name="expUnit" labelCol={{span: 12}} wrapperCol={{span: 12}}><Input /></Form.Item></Col>
              <Col span={10}><Form.Item label="Цвет" name="color" labelCol={{span: 12}} wrapperCol={{span: 12}}><ColorPicker /></Form.Item></Col>
            </Row>
          </Form.Item>
          {item?.vid === 0 && <Form.Item label="Приход, цена" className="sport-modal-group-item">
            <Row gutter={8}>
              <Col span={4}><Form.Item name="putPrice" noStyle><Input /></Form.Item></Col>
              <Col span={10}><Form.Item label="Единица" name="putUnit" labelCol={{span: 12}} wrapperCol={{span: 12}}><Input /></Form.Item></Col>
              <Col span={10}><Form.Item label="Коэфф." name="putCoeff" labelCol={{span: 12}} wrapperCol={{span: 12}}><Input onBlur={onPutCoeffBlur} /></Form.Item></Col>
            </Row>
          </Form.Item>}
          {item?.vid === 0 && <Form.Item label="Поставщик">
            <SelectClient value={item?.supplierId} onChange={e => onValuesChange({ supplierId: e.value })} defOptions={[{value: item?.supplierId, label: item?.supplierName}]} />
          </Form.Item>}
          {item?.vid === 0 && <Form.Item label="Мин. остаток" className="sport-modal-group-item">
            <Row gutter={8}>
              <Col span={4}><Form.Item name="restMin" noStyle><Input /></Form.Item></Col>
              <Col span={20}><Form.Item label="Мин. партия" name="restMinPart" labelCol={{span: 12}} wrapperCol={{span: 12}}><Input /></Form.Item></Col>
            </Row>
          </Form.Item>}
          <Form.Item label="Отдел ККМ" className="sport-modal-group-item">
            <Row gutter={8}>
              <Col span={4}><Form.Item name="depno" noStyle><Input /></Form.Item></Col>
              <Col span={20}><Form.Item label="Предмет расчета ККМ" name="kkmVid" labelCol={{span: 12}} wrapperCol={{span: 12}}><Select options={distsKKMTags1212} /></Form.Item></Col>
            </Row>
          </Form.Item>
          {item?.vid !== 3 && <Form.Item label="Артикул" className="sport-modal-group-item">
            <Row gutter={8}>
              <Col span={4}><Form.Item name="article" noStyle><Input /></Form.Item></Col>
              <Col span={20}><Form.Item label="Агент ККМ" name="kkmAgentName" labelCol={{span: 12}} wrapperCol={{span: 12}}><Input disabled /></Form.Item></Col>
            </Row>
          </Form.Item>}
          {(item?.vid === 2 || item?.vid === 3) && <Form.Item label="Указывать исполнителя" name="trainerSelectionRequirement">
            <Select
              options={[
                { label: "Не требуется", value: 0 },
                { label: "Клиент должен выбрать исполнителя", value: 1 },
                // { label: "Пользователь должен выбрать исполнителя", value: 2 },
                // { label: "И клиент, и пользователь должны выбрать исполнителя", value: 3 }
              ]}
            />
          </Form.Item>}
          {item?.vid === 0 && <>
            <Form.Item label="Штрихкод" name="barcode"><Input /></Form.Item>
            <Form.Item label=" " className="sport-section-title sport-modal-group-item">Маркировка</Form.Item>
            <Form.Item label="Вид" name="markVid"><Radio.Group options={productMarkVids} /></Form.Item>
            {item?.markVid === 2 && <>
              <Form.Item label="GTIN" name="markGtin"><Input /></Form.Item>
              <Form.Item label="Дробь" className="sport-modal-group-item">
              <Row gutter={8}>
                {/* <Col span={6}><Form.Item name="markUnit" noStyle><Select /></Form.Item></Col> */}
                <Col span={5}><Form.Item name="markNum" noStyle><Input /></Form.Item></Col>
                <Col span={5}><Form.Item name="markDen" label="/" noStyle><Input /></Form.Item></Col>
              </Row>
              </Form.Item></>
            }
          </>}

          {item?.vid === 4 && <>
            <Form.Item label=" " className="sport-section-title sport-modal-group-item">Условия использования</Form.Item>
            <Form.Item label="Срок действия" className="sport-modal-group-item">
            <Row gutter={8}>
              <Col span={3}><Form.Item name="srok" noStyle><Input /></Form.Item></Col>
              <Col span={9}><Form.Item name="srokVid" noStyle><Select options={datPeriodVids}/></Form.Item></Col>
            </Row>
          </Form.Item>
          </>}

          {item?.vid === 2 && <>
          <Form.Item label=" " className="sport-section-title sport-modal-group-item">Условия использования</Form.Item>
          <Form.Item label="График" name="calendarId"><Select options={calendars} allowClear/></Form.Item>
          <Form.Item label="Срок действия" className="sport-modal-group-item">
            <Row gutter={8}>
              <Col span={3}><Form.Item name="srok" noStyle><Input /></Form.Item></Col>
              <Col span={9}><Form.Item name="srokVid" noStyle><Select options={datPeriodVids}/></Form.Item></Col>
              <Col span={3}><Form.Item name="freezQty" noStyle><Input /></Form.Item></Col>
              <Col span={9}><Form.Item noStyle>Количество заморозок</Form.Item></Col>
            </Row>
          </Form.Item>
          <Form.Item label=" " className="sport-modal-group-item">
            <Row gutter={8}>
              <Col span={12} />
              <Col span={3}><Form.Item name="freezSrok" noStyle><Input /></Form.Item></Col>
              <Col span={9}><Form.Item noStyle>Общий срок заморозок</Form.Item></Col>
            </Row>
          </Form.Item>
          <Form.Item label="Кол. посещений" className="sport-modal-group-item">
            <Row gutter={8}>
              <Col span={3}><Form.Item name="limitVisitQty" noStyle><Input /></Form.Item></Col>
              <Col span={9}><Form.Item name="limitVisitQtyVid" noStyle><Select options={productLimitVisit} /></Form.Item></Col>
              <Col span={3}><Form.Item name="freezMin" noStyle><Input /></Form.Item></Col>
              <Col span={9}><Form.Item noStyle>Мин. срок заморозки</Form.Item></Col>
            </Row>
          </Form.Item>
          <Form.Item label=" " className="sport-modal-group-item">
            <Row gutter={8}>
              <Col span={3}><Form.Item name="paymentDeadline" noStyle><Input /></Form.Item></Col>
              <Col span={12} style={{ whiteSpace: "nowrap" }}><Form.Item noStyle>Срок полной оплаты, дней</Form.Item></Col>
              <Col span={9} />
            </Row>
          </Form.Item>
          </>}
          {item?.vid === 1 && <>
            <Form.Item label="Длительность" className="sport-modal-group-item" style={{marginBottom: "8px"}}>
              <Row gutter={8}>
                <Col span={4}><Form.Item name="duration" noStyle><Input /></Form.Item></Col>
                <Col span={20}><Form.Item name="graceTime" label="Льготное время" labelCol={{span: 12}} wrapperCol={{span: 4}}><Input /></Form.Item></Col>              
              </Row>
            </Form.Item>
            <Form.Item label="Вид планирования" name="recordVid" className="sport-modal-group-item">
              <Select options={planningVids} />
            </Form.Item>
            <Form.Item label="Услуга штрафа" name="penProductId" className="sport-modal-group-item" style={{marginTop: "8px"}}>
              <Select options={penProductIds} allowClear showSearch optionFilterProp="label" />
            </Form.Item>
          </>}
          {(item?.vid === 2 || item?.vid === 3) && <Form.Item label=" " className="sport-modal-group-item">
            <Row gutter={8} align="middle">
              <Col><Form.Item name="autoActivationDays" noStyle><Input disabled={item?.autoActivationOnFullPayment} style={{width: 60}}/></Form.Item></Col>
              <Col style={{ whiteSpace: "nowrap" }}><Form.Item noStyle>Срок автоактивации, дней</Form.Item></Col>
              <Col style={{ paddingLeft: 4, paddingTop: 4 }}><Form.Item name="closeIfUsed" valuePropName="checked" noStyle><Checkbox>Закрыть, если услуги использованы</Checkbox></Form.Item></Col>
              <Col style={{ paddingLeft: 4, paddingTop: 4 }}><Form.Item name="autoActivationOnFullPayment" valuePropName="checked" noStyle><Checkbox>Автоактивация при полной оплате</Checkbox></Form.Item></Col>
            </Row>
            {item?.vid === 2 && <Row gutter={8} align="middle" style={{marginTop: 4}}>
              <Col style={{ paddingLeft: 4, paddingTop: 4 }}><Form.Item className="sport-modal-group-item" name="saleUseOnVisit" valuePropName="checked"><Checkbox>Списывать услугу при входе</Checkbox></Form.Item></Col>
            </Row>}
          </Form.Item>}
          <Form.Item label=" " className="sport-section-title sport-modal-group-item">Расчет зарплаты</Form.Item>
          <Form.Item label="Исполнителю, %" className="sport-modal-group-item">
            <Row gutter={8}>
              <Col span={4}><Form.Item name="salaryExec" noStyle
              getValueFromEvent={(e) => (e.target.value === "" ? 0 : e.target.value)}>
                <Input /></Form.Item></Col>
              <Col span={10}><Form.Item label="Польз-лю, %" name="salarySale" 
              getValueFromEvent={(e) => (e.target.value === "" ? 0 : e.target.value)}
              labelCol={{span: 16}} wrapperCol={{span: 8}}><Input /></Form.Item></Col>
              <Col span={10}><Form.Item label="Менеджеру, %" name="salaryManager" 
              getValueFromEvent={(e) => (e.target.value === "" ? 0 : e.target.value)}
              labelCol={{span: 16}} wrapperCol={{span: 8}}><Input /></Form.Item></Col>
            </Row>
          </Form.Item>
          {id ? <Form.Item label="Картинка" className="sport-modal-group-item" style={{ marginBottom: 16 }}>
            <div className="product-photo">
              <img ref={imageRef} src={item?.pictureId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.pictureId}.jpg` : "/images/picture.svg"} alt="product" className="product-photo-picture" />
              <img src="/images/photo.svg" alt="take-photo" className="product-photo-button" onClick={() => setTakePhoto(true)} />
              <img src="/images/upload-photo.svg" alt="upload-photo" className="product-photo-upload-button" onClick={() => setUploadPhoto(true)} />
              {item?.imageId ? <img src="/images/delete-button.svg" alt="delete-photo" className="product-photo-delete-button" onClick={() => onDeletePhoto()} /> : null}
            </div>
            {takePhoto && <TakePhoto onClose={onClosePhoto} onSave={onSavePhoto} />}
            {uploadPhoto && <UploadPhoto onClose={onCloseUpload} onSave={onSavePhoto} />}
          </Form.Item> : null}
          <Form.Item label=" ">
            <Space>
              <LogMonitor vid={2} id={id} />
              <Button className="sport-btn" onClick={onSave}>Сохранить</Button>
              <Popconfirm title="Подтверждение" description="Скопировать?" onConfirm={onCopy}><Button className="sport-btn">Копия</Button></Popconfirm>
              <Popconfirm title="Подтверждение" description="Удалить?" onConfirm={onDelete}><Button className="sport-btn" disabled={!id}>Удалить</Button></Popconfirm>
              <Button className="sport-btn" onClick={onCancel}>Закрыть</Button>
            </Space>
          </Form.Item>
        </Form>
        <Scan onScan={onScan}/>
  </> :
  <div className="product-mobile-container">
    <div className="sales-buttons-line-triple-halfed" style={{marginTop: "4px"}}>
      <Button style={{width: "100%"}} onClick={onSave}>Сохранить</Button>
      <Popconfirm title="Подтверждение" description="Скопировать?" onConfirm={onCopy} placement="bottom" getPopupContainer={(trigger) => trigger.closest('.sales-buttons-line-triple-halfed')} overlayClassName="centered-popconfirm">
        <Button style={{width: "100%"}}>Копия</Button>
      </Popconfirm>
      <Popconfirm title="Подтверждение" description="Удалить?" onConfirm={onDelete} placement="bottom" getPopupContainer={(trigger) => trigger.closest('.sales-buttons-line-triple-halfed')} overlayClassName="centered-popconfirm">
        <Button style={{width: "100%"}} disabled={!id}>Удалить</Button>
      </Popconfirm>
    </div>
    <div className="product-mobile-scroll">
    <Form form={form} onValuesChange={onValuesChange} labelCol={{ span: 3 }} colon={false} disabled={loading} layout="inline">
      <Form.Item label="Вид" className="record-form-item-with-margin-top-mobile">
        <Row align="middle" className="records-row-mobile">
          <Col>
            <Form.Item name="vid">
              <Select className="product-type-big-select-mobile" options={productVids}/>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label="Актив." name="active" valuePropName="checked">
              <Checkbox/>
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>

      <Form.Item className="settings-mobile-form-item" label="Наимен." name="name">
        <Input/>
      </Form.Item>
      <Form.Item className="settings-mobile-form-item" label="Описание" name="description">
        <Input.TextArea rows={3}/>
      </Form.Item>
      <Form.Item label="Прод. цена" className="record-form-item-with-margin-top-mobile">
        <Row align="middle" className="product-row-mobile">
          <Col>
            <Form.Item name="expPrice">
              <Input className="product-small-input-mobile"/>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item labelCol={{ style: { width: 'auto', minWidth: 'unset', fontSize: '12px' } }} label="Цвет" name="color">
              <ColorPicker className="product-color-picker-mobile" placement="bottom"
                getPopupContainer={() => document.querySelector('.record-form-item-with-margin-top-mobile') || document.body}/>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item labelCol={{ style: { width: 'auto', minWidth: 'unset', fontSize: '12px' } }} label="Ед." name="expUnit">
              <Input className="product-small-input-mobile"/>
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>

      {item?.vid === 0 && <Form.Item label="Прих. цена" className="record-form-item-with-margin-top-mobile">
        <Row align="middle" className="product-row-mobile">
          <Col>
            <Form.Item name="putPrice"><Input className="product-small-input-mobile"/></Form.Item>
          </Col>
          <Col>
            <Form.Item labelCol={{ style: { width: 'auto', minWidth: 'unset', fontSize: '12px' } }} label="Ед." name="putUnit">
              <Input className="product-small-input-mobile" />
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label="Коэфф." name="putCoeff" labelCol={{ style: { width: 'auto', minWidth: 'unset', fontSize: '12px' } }}>
              <Input className="product-extra-small-input-mobile" onBlur={onPutCoeffBlur}/>
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>}
      {item?.vid === 0 && <Form.Item label="Поставщик " className="record-form-item-with-margin-top-mobile">
        <SelectClient value={item?.supplierId} onChange={e => onValuesChange({ supplierId: e.value })} defOptions={[{value: item?.supplierId, label: item?.supplierName}]} 
          className="product-select-client"/>
      </Form.Item>}

      {item?.vid === 0 && <Form.Item label="Мин. ост." className="record-form-item-with-margin-top-mobile">
        <Row align="middle" className="product-row-mobile">
          <Col>
            <Form.Item name="restMin">
              <Input className="product-small-input-mobile"/>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label="Мин. партия" name="restMinPart">
              <Input className="product-small-input-mobile"/>
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>}

      <Form.Item label="Отд. ККМ" className="record-form-item-with-margin-top-mobile">
        <Row align="middle" className="product-row-mobile" gutter={0}>
          <Col>
            <Form.Item name="depno">
              <Input className="product-extra-small-input-mobile"/>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item labelCol={{ style: { width: 'auto', minWidth: 'unset', fontSize: '12px' } }} style={{minWidth: ""}} label="Предм. ККМ" name="kkmVid">
              <Select className="product-type-select-mobile" options={distsKKMTags1212} />
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>

      {item?.vid !== 3 && <Form.Item label="Артикул" className="record-form-item-with-margin-top-mobile">
        <Row align="middle" className="product-row-mobile">
          <Col>
            <Form.Item name="article">
              <Input className="product-small-input-mobile"/>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label="Агент ККМ" name="kkmAgentName" labelCol={{ style: { width: 'auto', minWidth: 'unset', fontSize: '12px' } }}>
              <Input disabled className="product-small-input-mobile"/>
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>}
      {item?.vid === 0 && <>
        <Form.Item label="Штрихкод" name="barcode" className="record-form-item-with-margin-top-mobile">
          <Input />
        </Form.Item>

        <Form.Item label=" " className="records-form-item-mobile" style={{fontWeight: 600}}>Маркировка</Form.Item>
        <Form.Item label="Вид" name="markVid" className="records-form-item-mobile" labelCol={{ style: { width: 'auto', whiteSpace: 'nowrap' } }}>
          <Radio.Group className="product-markVid-radio" options={productMarkVidsMobile} />
        </Form.Item>
        {item?.markVid === 2 && <>
          <Form.Item label="GTIN" name="markGtin" className="record-form-item-with-margin-top-mobile" labelCol={{ style: { width: 'auto', whiteSpace: 'nowrap' } }}>
            <Input />
          </Form.Item>
          <Form.Item label="Дробь" className="record-form-item-with-margin-top-mobile settings-mobile-form-item product-fraction-row" labelCol={{ style: { width: 'auto', whiteSpace: 'nowrap' } }} wrapperCol={{ style: { flex: 1 } }}>
            <Form.Item name="markNum" noStyle><Input/></Form.Item>
            <span>/</span>
            <Form.Item name="markDen" noStyle><Input/></Form.Item>
          </Form.Item></>
        }
      </>}
      {(item?.vid === 2 || item?.vid === 3) && <Form.Item className="settings-mobile-form-item record-form-item-with-margin-top-mobile" label="Указывать исполнителя" name="trainerSelectionRequirement" labelCol={{ span: 24, style: { textAlign: 'left' } }} wrapperCol={{ span: 24 }}>
        <Select className="product-trainer-select-mobile"
          options={[
            { label: "Не требуется", value: 0 },
            { label: "Клиент должен выбрать исполнителя", value: 1 },
            // { label: "Пользователь должен выбрать исполнителя", value: 2 },
            // { label: "И клиент, и пользователь должны выбрать исполнителя", value: 3 }
          ]}
        />
      </Form.Item>}
      {item?.vid === 2 && <> <Form.Item label=" " className="records-form-item-mobile" style={{fontWeight: 600}}>Условия использования</Form.Item>
        <Form.Item label="График" name="calendarId" className="record-form-item-with-margin-top-mobile" labelCol={{ style: { width: 'auto', whiteSpace: 'nowrap' } }}>
          <Select options={calendars} allowClear className="records-form-item-mobile"/>
        </Form.Item>

        <Form.Item label="Срок" className="record-form-item-with-margin-top-mobile" labelCol={{ style: { width: 'auto', whiteSpace: 'nowrap', fontSize: '12px' } }}>
          <Row align="middle" className="product-row-mobile">
            <Col><Form.Item name="srok" noStyle><Input className="product-extra-small-input-numbers-mobile"/></Form.Item></Col>
            <Col><Form.Item name="srokVid" noStyle><Select className="product-type-small-select-mobile" options={datPeriodVids}/></Form.Item></Col>
            <Col><Form.Item name="freezQty" label="Кол. замор."><Input className="product-extra-small-input-numbers-mobile"/></Form.Item></Col>
          </Row>
        </Form.Item>

        <Form.Item label=" " className="record-form-item-with-margin-top-mobile" labelCol={{ style: { width: 'auto', whiteSpace: 'nowrap' } }}>
          <Row align="middle" className="product-row-mobile" style={{ justifyContent: 'flex-end' }}>
            <Form.Item name="freezSrok" label="Общ. замор."><Input className="product-extra-small-input-numbers-mobile"/></Form.Item>
          </Row>
        </Form.Item>
        <Form.Item label="Кол. посещ." className="record-form-item-with-margin-top-mobile" labelCol={{ style: { width: 'auto', whiteSpace: 'nowrap', fontSize: '12px' } }}>
          <Row align="middle" className="product-row-mobile">
            <Col><Form.Item name="limitVisitQty" noStyle><Input className="product-extra-small-input-numbers-mobile"/></Form.Item></Col>
            <Col><Form.Item name="limitVisitQtyVid" noStyle><Select className="product-type-small-select-mobile" options={productLimitVisit}/></Form.Item></Col>
            <Col><Form.Item name="freezMin" label="Мин. замор."><Input className="product-extra-small-input-numbers-mobile"/></Form.Item></Col>
          </Row>
        </Form.Item>
        <Form.Item label=" " className="record-form-item-with-margin-top-mobile" labelCol={{ style: { width: 'auto', whiteSpace: 'nowrap' } }}>
          <Row align="middle" className="product-row-mobile" style={{ justifyContent: 'flex-start' }}>
            <Col><Form.Item name="paymentDeadline" noStyle><Input className="product-extra-small-input-numbers-mobile"/></Form.Item></Col>
            <Col style={{ whiteSpace: "nowrap" }}><Form.Item noStyle>Срок полной оплаты, дней</Form.Item></Col>
          </Row>
        </Form.Item>
      </>}
      {item?.vid === 4 && <> <Form.Item label=" " className="records-form-item-mobile" style={{fontWeight: 600}}>Условия использования</Form.Item>
        <Form.Item label="Срок" className="record-form-item-with-margin-top-mobile" labelCol={{ style: { width: 'auto', whiteSpace: 'nowrap', fontSize: '12px' } }}>
          <Row align="middle" >
            <Col><Form.Item name="srok" noStyle><Input className="product-extra-small-input-numbers-mobile"/></Form.Item></Col>
            <Col><Form.Item name="srokVid" noStyle><Select style={{marginLeft: "8px"}} className="product-type-small-select-mobile" options={datPeriodVids}/></Form.Item></Col>
          </Row>
        </Form.Item>
      </>}
      {item?.vid === 1 && <>
        <Form.Item label="Длител." name="duration" className="settings-mobile-form-item">
          <Input/>
        </Form.Item>
        <Form.Item label="Вид план." name="recordVid" className="settings-mobile-form-item">
          <Select options={planningVids}/>
        </Form.Item>
      </>}
      {(item?.vid === 2 || item?.vid === 3) && <>
        <Form.Item
          label=" "
          className="record-form-item-with-margin-top-mobile"
          labelCol={{ style: { width: 'auto', whiteSpace: 'nowrap' } }}
        >
          <Row align="middle" className="product-row-mobile" style={{ justifyContent: 'flex-start' }}>
            <Col>
              <Form.Item name="autoActivationDays" noStyle>
                <Input
                  disabled={item?.autoActivationOnFullPayment}
                  className="product-extra-small-input-numbers-mobile"
                />
              </Form.Item>
            </Col>
            <Col style={{ whiteSpace: "nowrap" }}>
              <Form.Item noStyle>Срок автоактивации, дней</Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <div className="product-checkboxes-mobile">
          <Form.Item name="closeIfUsed" valuePropName="checked" noStyle>
            <Checkbox>Закрыть, если услуги использованы</Checkbox>
          </Form.Item>
        </div>
        <div className="product-checkboxes-mobile">
          <Form.Item name="autoActivationOnFullPayment" valuePropName="checked" noStyle>
            <Checkbox>Автоактивация при полной оплате</Checkbox>
          </Form.Item>
        </div>
        {item?.vid === 2 && <div className="product-checkboxes-mobile">
          <Form.Item name="saleUseOnVisit" valuePropName="checked" noStyle>
            <Checkbox>Списывать услугу при входе</Checkbox>
          </Form.Item>
        </div>}
      </>}
      <Form.Item label=" " className="records-form-item-mobile" style={{fontWeight: 600}}>Расчет зарплаты</Form.Item>
      <Form.Item label="Исполн., %" className="record-form-item-with-margin-top-mobile">
        <Row align="middle" className="product-row-mobile">
          <Col>
            <Form.Item name="salaryExec" getValueFromEvent={(e) => (e.target.value === "" ? 0 : e.target.value)}>
              <Input className="product-extra-small-input-numbers-mobile"/>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label="Польз., %" name="salarySale" getValueFromEvent={(e) => (e.target.value === "" ? 0 : e.target.value)} labelCol={{ style: { width: 'auto', minWidth: 'unset', fontSize: '12px' } }}>
              <Input className="product-extra-small-input-numbers-mobile"/>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item label="Менедж., %" name="salaryManager" getValueFromEvent={(e) => (e.target.value === "" ? 0 : e.target.value)} labelCol={{ style: { width: 'auto', minWidth: 'unset', fontSize: '12px' } }}>
              <Input className="product-extra-small-input-numbers-mobile"/>
            </Form.Item>
          </Col>
        </Row>
      </Form.Item>
      {id ? <Form.Item label="Картинка" className="record-form-item-with-margin-top-mobile product-photo-form-item" labelCol={{ style: { width: 'auto', whiteSpace: 'nowrap' } }} style={{ marginBottom: 16 }}>
        <div className="product-photo-mobile">
          <img ref={imageRef} src={item?.pictureId ? `${process.env.REACT_APP_API_BASE_URL}/api/image/${item.pictureId}.jpg` : "/images/picture.svg"} alt="product" className="product-photo-picture-mobile" />
          <div className="product-photo-buttons-mobile">
            <img src="/images/photo.svg" alt="take-photo" style={{ cursor: 'pointer' }} onClick={() => setTakePhoto(true)} />
            <img src="/images/upload-photo.svg" alt="upload-photo" style={{ cursor: 'pointer' }} onClick={() => setUploadPhoto(true)} />
            {item?.imageId ? <img src="/images/delete-button.svg" alt="delete-photo" style={{ cursor: 'pointer', height: 28, width: 28 }} onClick={() => onDeletePhoto()} /> : null}
          </div>
        </div>
        {takePhoto && <TakePhoto onClose={onClosePhoto} onSave={onSavePhoto} />}
        {uploadPhoto && <UploadPhoto onClose={onCloseUpload} onSave={onSavePhoto} />}
      </Form.Item> : null}
    </Form>
    </div>
    <Scan onScan={onScan}/>
  </div>
}

export default ProductMain;